import r from "../managers/braze-instance.js";
import ie from "./feed-provider-factory.js";
export function requestFeedRefresh() {
  if (r.rr()) return ie.m().bi();
}
